import { render } from "./read-banner.vue?vue&type=template&id=bc40cb34&scoped=true"
import script from "./read-banner.vue?vue&type=script&lang=js"
export * from "./read-banner.vue?vue&type=script&lang=js"

import "./read-banner.vue?vue&type=style&index=0&id=bc40cb34&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc40cb34"]])

export default __exports__